<app-side-modal
  [ngSwitch]="balanceAction"
  #sideModal
  (goBack)="sideModal.handleHide()"
  (hideModal)="closeBalanceAction()"
>
  <hb-trade-transfer
    *ngSwitchCase="'transfer'"
    [transferAccounts]="transferAccounts$ | async"
    [currentContract]="currentContract"
    [isUsaContract]="isUsaContract"
    (onTranfered)="closeBalanceAction()"
    [isGeolocationEnabled]="!(shouldRestrictBalanceActions$ | async)"
    [getContractCashLayers$]="getContractCashLayers$"
  ></hb-trade-transfer>
</app-side-modal>

<hb-trade-cash
  *ngIf="balanceAction === 'withdrawal'"
  [selectedLoremAccount]="selectedLoremAccount$ | async"
  [isUsaContract]="isUsaContract"
  (onCloseWithdrawal)="closeBalanceAction()"
  [isGeolocationEnabled]="!(shouldRestrictBalanceActions$ | async)"
  [getContractCashLayers$]="getContractCashLayers$"
></hb-trade-cash>

<div *ngIf="!isGlobalContract" class="balance-actions">
  <deposit-account
    *ngIf="showDepositAccount"
    [currentContract]="currentContract"
    (onClose)="toggleOpenDepositAccount()"
    (isLoadedDepositAccount)="
      isVisibleDepositAccount = !isVisibleDepositAccount
    "
  ></deposit-account>
  <div
    class="balance-actions__container"
    [class.balance-actions--deposits]="isVisibleDepositAccount"
  >
    <button
      (click)="toggleOpenDepositAccount()"
      class="button-fab button-fab--deposit button-fab--with-description"
      tourAnchor="balance-actions-deposit"
      data-tour-anchor="balance-actions-deposit"
    >
      <div class="button-fab"></div>
      <span>Depositar</span>
    </button>
    <button
      *ngIf="showTransferButton"
      (click)="openTransferAction()"
      class="button-fab button-fab--transfer button-fab--with-description"
      [ngClass]="{ 'button-fab--loading': isTransferButtonLoading }"
      [disabled]="!(canTransfer$ | async)"
    >
      <div class="button-fab">
        <div class="button-fab__loader" *ngIf="isTransferButtonLoading">
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <span>Transferir</span>
    </button>
    <button
      (click)="openWithdrawalAction()"
      class="button-fab button-fab--withdraw button-fab--with-description"
      [ngClass]="{ 'button-fab--loading': isWithdrawalButtonLoading }"
      [disabled]="disabledTradingUsaOperation"
    >
      <div class="button-fab">
        <div class="button-fab__loader" *ngIf="isWithdrawalButtonLoading">
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <span>Retirar</span>
    </button>
  </div>
</div>
